import styled from 'styled-components';

export const StyledStepLabel = styled.div`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 5px;
  width: max-content;
  max-width: 116px;
  text-align: center;
`;
